import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=441a2f1e&scoped=true&"
import script from "./baseData.vue?vue&type=script&lang=js&"
export * from "./baseData.vue?vue&type=script&lang=js&"
import style0 from "./baseData.vue?vue&type=style&index=0&id=441a2f1e&scoped=true&lang=css&"
import style1 from "./baseData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a2f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441a2f1e')) {
      api.createRecord('441a2f1e', component.options)
    } else {
      api.reload('441a2f1e', component.options)
    }
    module.hot.accept("./baseData.vue?vue&type=template&id=441a2f1e&scoped=true&", function () {
      api.rerender('441a2f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/baseData.vue"
export default component.exports